import {
  ColorValues,
  Divider,
  Flex,
  Spinner,
  Switch,
  Typography,
  useScreenSize,
} from '@banhala/ui-kit';
import { BrandIconTodayShipping } from 'shared/src/component';
import { isIOS, localizeNumber } from 'shared/src/utils';

interface GoodsListHeaderProps {
  totalCount: number;
  showDeliveryFilter: boolean;
  isDeliveryFilterOn: boolean;
  isLoading: boolean;
  onChangeDeliveryFilter: (next: boolean) => void;
}

export const GoodsListHeader = ({
  totalCount,
  showDeliveryFilter,
  isDeliveryFilterOn,
  isLoading,
  onChangeDeliveryFilter,
}: GoodsListHeaderProps) => {
  const { width: screenWidth } = useScreenSize();

  return (
    <Flex alignItems={'center'}>
      <Flex width={screenWidth}>
        <Flex.Row
          alignItems="center"
          justifyContent="space-between"
          padding={{ horizontal: 16, vertical: 12 }}
        >
          {isLoading ? (
            <Spinner size={16} />
          ) : (
            <Typography type="body3" color="content_secondary">
              총 {localizeNumber(totalCount)}개
            </Typography>
          )}
          {showDeliveryFilter && (
            <Flex.Row alignItems="center">
              <Switch
                value={isDeliveryFilterOn}
                onChange={onChangeDeliveryFilter}
                color={'lilac'}
                scale={isIOS ? 0.7 : undefined}
              />
              <Flex margin={{ left: isIOS ? -8 : 0 }}>
                <BrandIconTodayShipping
                  width={49}
                  height={14}
                  color={ColorValues.lilac40}
                />
              </Flex>
            </Flex.Row>
          )}
        </Flex.Row>
        <Divider size="small" />
      </Flex>
    </Flex>
  );
};
